const awsconfig = {
  Auth: {
    Cognito: {
      userPoolClientId: 'nrehh099g9qb752q32lccpdac',
      userPoolId: 'us-west-2_o1NJY1DP0',
      loginWith: {
        oauth: {
          domain: 'auth.dev.matersci.com',
          scope: ['email', 'openid', 'profile'],
          redirectSignIn: 'https://dev.matersci.com/callback',
          redirectSignOut: 'https://dev.matersci.com/logout',
          responseType: 'code',
        },
        username: 'true',
        email: 'false', // Optional
        phone: 'false', // Optional
      }
    }
  }
};

export default awsconfig;